import { slice } from 'lodash';

import { SET_CALL_ID } from '../../actions/actionTypes/debug';

export const initialState = {
    callIds: [] as CallIdItem[]
};

interface CallIdItem {
    callId: string;
    timestamp: number;
}

interface DebugState {
    callIds: CallIdItem[];
}

interface ReducerAction {
    type: string;
    payload?: {
        callId?: string;
        timestamp?: number;
    };
}

const debug = (state: DebugState | undefined, action: ReducerAction): DebugState => {
    const currentState = state ?? initialState;
    const { type, payload } = action;

    switch (type) {
        case SET_CALL_ID: {
            const { callId = '', timestamp = Date.now() } = payload || {};

            const newCallIds = [...currentState.callIds, { callId, timestamp }];

            return { callIds: slice(newCallIds, -10, newCallIds.length) };
        }
        default: {
            return currentState;
        }
    }
};

export default debug;
